<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {
                menuOpen: false
            }
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        computed: {
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            toggleMenu() {
                if (this.menuOpen) {
                    this.menuOpen = false
                } else {
                    this.menuOpen = true
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-09-Iframe-01.vue